export default {
  component: () => import('./page.vue'),
  path: '/apply/:serial',
  name: 'apply',
  meta: {
    title: '申请加入',
    auth: true,
    wechat: {
      openTagList: ['wx-open-launch-app', 'wx-open-launch-weapp'],
    },
  },
};
